import { connect } from 'react-redux';
import { compose } from 'redux';
import { attSubPageWithoutUpcomingDetails } from 'decorators/subPage';
import notePage from 'decorators/notePage';

import { findAttSub, updateAttSub } from 'actions/attSubs';
import { fetchAndAllowResellerToggleStatus } from 'actions/resellers';
import { fetchAttSubContract } from 'actions/insuranceContracts';
import {
  getIncludedInGroups,
  getSubContracts,
  getIsAdmin,
  getLoggedInUser,
} from 'reducers';

import ViewSub from './ViewSub';
import AttSub from 'components/AttSub/AttSub';
import AttSubActions from 'components/SubActions/att';

const mapStateToProps = (state, { subId }) => ({
  isAdmin: getIsAdmin(state),
  isAdminOrManagerOrBusiness: getIncludedInGroups(state, [
    'ADMIN',
    'MANAGER',
    'BUSINESS',
  ]),
  isReseller: getIncludedInGroups(state, ['RESELLER']),
  contracts: getSubContracts(state, subId, 'att'),
  pageUrl: (subId, pageNum) =>
    `/att/subscription/${subId}/view?page=${pageNum}`,
  Sub: AttSub,
  loggedInUser: getLoggedInUser(state),
  SubActions: AttSubActions,
});

const mapDispatchToProps = {
  fetchSubContract: fetchAttSubContract,
  findSub: findAttSub,
  fetchAndAllowResellerToggleStatus,
  updateSub: updateAttSub,
};

export default compose(
  attSubPageWithoutUpcomingDetails,
  notePage,
)(connect(mapStateToProps, mapDispatchToProps)(ViewSub));
